import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { sendAnalyticsEvents } from '../../analytics/common';
import { EVENTS } from '../../analytics/events';
import AppButton from '../../components/AppButton';
import AppSubtitle from '../../components/AppSubtitle';
import AppTitle from '../../components/AppTitle';
import { selectEventsData } from '../../store/events';
import { selectWebp } from '../../store/ui';
import { TargetTrackImagesLinks } from '../../utils/utils';
import { usePreloadImages } from '../../hooks/useImagePreloader';
import { selectLandingAnimation } from '../../store/plans';
import useWindowWidth from '../../hooks/useWindowWidth';

const StyledImage = styled.div`
  background-image: ${({ imgSource }) => imgSource && `url('${imgSource}')`};
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  display: flex;
  width: 100vw;
  max-height: 300px;
  height: 100%;
  @media screen and (min-width: 376px) {
    background-image: ${({ imgSource }) => imgSource && `url('${imgSource}')`};
    max-height: 512px;
    background-size: 90%;
    background-position: center;
  }
  @media screen and (min-width: 450px) {
    background-size: contain;
    min-height: 150px;
  }
`;

const StyledContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  // max-height: 80px;
  min-height: 150px;
  min-width: 330px;
  margin-bottom: 34px;
  @media screen and (min-width: 450px) {
    margin-bottom: 20px;
  }
`;

const LowBatteryNotification = () => {
  const navigate = useNavigate();
  const eventsData = useSelector(selectEventsData);
  const { t } = useTranslation();
  const isWebp = useSelector(selectWebp);
  const isAnimationLanding = useSelector(selectLandingAnimation);
  const windowWidth = useWindowWidth();
  usePreloadImages(TargetTrackImagesLinks);
  useEffect(
    () => sendAnalyticsEvents(EVENTS.onboardingBattery, eventsData),
    [eventsData]
  );

  const onContinueClick = () => {
    sendAnalyticsEvents(EVENTS.onboardingBatterySubmitted, eventsData);
    navigate('/choose-target');
  };

  const imgSource = isAnimationLanding
    ? '../assets/desktop/anim/Low_battery_notification.gif'
    : windowWidth >= 375 && isWebp
    ? '../assets/desktop/webp/Low_battery_notification.webp'
    : windowWidth >= 375 && !isWebp
    ? '../assets/desktop/png/Low_battery_notification.png'
    : windowWidth < 375 && isWebp
    ? '../assets/mobile/webp/Low_battery_notification.webp'
    : '../assets/mobile/png/Low_battery_notification.png';

  return (
    <>
      <StyledImage imgSource={imgSource} />
      <StyledContent>
        <AppTitle
          containerWidth={'370px'}
          title={t('low_battery')}
          marginContainer={'0px 0px 12px 0px'}
        />
        <AppSubtitle
          containerWidth={'250px'}
          subtitle={t('low_battery_description')}
        />
      </StyledContent>
      <AppButton
        onClick={onContinueClick}
        bottomPosition={'24px'}
        customBeforeBg={'none'}
      >
        {t('continue')}
      </AppButton>
    </>
  );
};

export default LowBatteryNotification;
